import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {connect} from "react-redux";
import ClientSlider from './ClientSlider';
import $ from "jquery/dist/jquery.js";

class Client extends Component {

    constructor(props)
    {
        super(props);
        this.state = {
        }

    }

    componentWillMount() { 
    }

    componentDidMount() {

        ReactDOM.render(<ClientSlider clients= {this.props.clients} />, document.getElementById('client_slider_container'));
        setTimeout(() => {
            window.initClientSlider();
        }, 100);
    }
  
    componentWillUnmount() {
        
    }
  
    componentWillReceiveProps(newProps) {
        ReactDOM.unmountComponentAtNode($('#client_slider_container')[0]);
        ReactDOM.render(<ClientSlider clients= {newProps.clients} />, document.getElementById('client_slider_container'));
        setTimeout(() => {
            window.initClientSlider();
        }, 100);
    }

    componentDidUpdate() {
       
    }
  
    render() {
        return (
            <div className="container">
                <h4 className="mt-4 mb-4">{this.props.clientCaption}</h4>
                <div id="client_slider_container">  
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { 
        language: state.language
    };
}

export default connect(mapStateToProps)(Client);